import { createAsyncThunk } from '@reduxjs/toolkit'
import { ServiceConfig } from '../services/config'
import { APIError, get, post } from '../services/crud'
import { ILocation, IServiceLocationDetails } from './typings'
import { StoreData } from '../reducers/typings'
import { ODataResponse, LocationDTO } from '@sales-center/common'
import buildQuery from 'odata-query'

const baseOdataUrl = `${ServiceConfig.baseAPIUrl}${ServiceConfig.location.odata}`
const baseUrl = `${ServiceConfig.baseAPIUrl}${ServiceConfig.location.location}`

export const getLocations = createAsyncThunk<
  ODataResponse<ILocation>,
  void,
  { rejectValue: APIError }
>('locations/cards', async (_, thunkApi) => {
  const {
    locations: {
      page,
      perPage,
      filterSet: { normalizedFilters, orderBy },
    },
  } = thunkApi.getState() as StoreData

  const qstring = buildQuery<ILocation>({
    count: true,
    skip: (page - 1) * perPage,
    top: perPage,
    orderBy,
    filter: normalizedFilters,
  })

  const response = await get(`${baseOdataUrl}${qstring}`)

  if (response.ok) return await response.json()
  return thunkApi.rejectWithValue(await response.json())
})

export const getLocationDetails = createAsyncThunk<
  IServiceLocationDetails,
  number
>('locationDetails/card', async (locationId, thunkApi) => {
  const response = await get(`${baseUrl}/core/${locationId}`)
  if (response.ok) return await response.json()
  return thunkApi.rejectWithValue(await response.json())
})

export const getLocationsBulk = createAsyncThunk<
  LocationDTO[],
  string[],
  { rejectValue: APIError }
>('locations/ServiceLocations', async (ids, thunkApi) => {
  const response = await post(`${baseUrl}/core/bulk`, ids)

  if (response.ok) {
    return await response.json()
  }

  return thunkApi.rejectWithValue((await response.json()) as APIError)
})
